import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

const EmploymenttypeFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    casual_employment: false,
  });
  const [companies, setCompanies] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [relations, setRelations] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().employmentTypeId) || (entity === 'employment-type' && id)) {
      apiCall('patch', '/api/v2/employment-type/' + id, data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEmploymenttypeList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/employment-type', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEmploymenttypeList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/hr/employment-type/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    let _emloyeeQuery = {
      rows: 9999
    }
    let emloyeeQuery = window.App.transformQueryParams(_emloyeeQuery)
    apiCall('get', '/api/v2/employee' + emloyeeQuery)
      .then(response => {
        setEmployees(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/dictionary/employment-relation')
      .then(response => {
        setRelations(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/company')
      .then(response => {
        setCompanies(response.data.data?.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().employmenttypeId) || (entity === 'employment-type' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/employment-type/' + (window.App.urlVars().employmentId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"employment-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="company" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="company"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompany')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(companies, "name")}
                               id={"company"}
                               disabled={window.App.urlVars().employeeId}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCompanyYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   company: e.value
                                 })
                               }}
                               value={formData.company?.id || formData.company}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="working_hours" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldWorkingHours')}</label>
                  <span className="p-d-block">
                      <InputNumber id="working_hours" {...input}
                                   onValueChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       working_hours: e.value
                                     })
                                   }}
                                   value={formData.working_hours}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="probation_approver" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="probation_approver"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProbationDecisionMaker')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(employees, "name")}
                               id={"probation_approver"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noEmployeeYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   probation_approver: e.value
                                 })
                               }}
                               filter
                               value={formData.probation_approver?.id || formData.probation_approver}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="probation_over_notify_before" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="probation_over_notify_before"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProbationOverNotifyBefore')}</label>
                  <span className="p-d-block">
                     <InputNumber id="probation_over_notify_before" {...input}
                                  onValueChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      probation_over_notify_before: e.value
                                    })
                                  }}
                                  value={formData.probation_over_notify_before}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="employment_relation" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="employment_relation"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmploymentRelation')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(relations, "value")}
                               id={"employment_relation"}
                               optionValue={"value"}
                               optionLabel={"value"}
                               emptyMessage={t('noElementYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   employment_relation: e.value
                                 })
                               }}
                               filter
                               value={formData.employment_relation?.id || formData.employment_relation}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {/*<div className={"p-col-12 p-lg-2"}>*/}
            {/*  <Field name="casual_employment" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="name"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldSimplifiedEmployment')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*        <InputSwitch*/}
            {/*          className={"p-mt-1"}*/}
            {/*          checked={formData.casual_employment}*/}
            {/*          value={formData.casual_employment}*/}
            {/*          onChange={e => setFormData({...formData, casual_employment: e.target.value})}/>*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'employment-type' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(EmploymenttypeFormComponent);
